import { useEffect, useState } from "react";
import { generateSignupQrDataUrl } from "../../lib/qr";
import { CopyField } from "../CopyField/CopyField";
import { InlineNotice } from "../InlineNotice/InlineNotice";
import { Spinner } from "../Spinner/Spinner";
import styles from "./QrPanel.module.css";

export function QrPanel({ tenantName, url }: { tenantName: string; url: string }) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setDataUrl(null);
    setError(null);
    generateSignupQrDataUrl(url)
      .then((result) => {
        if (!cancelled) setDataUrl(result);
      })
      .catch(() => {
        if (!cancelled) setError("Couldn't generate the QR code. The link below still works.");
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  return (
    <div className={styles.panel}>
      <div className={styles.qrWrap}>
        {dataUrl && (
          <img className={styles.qrImage} src={dataUrl} alt={`QR code that opens ${tenantName}'s signup page`} />
        )}
        {!dataUrl && !error && <Spinner label="Rendering QR" />}
      </div>
      <div className={styles.details}>
        <span className={styles.caption}>Signup destination</span>
        <CopyField value={url} label={`${tenantName} signup link`} />
        {error && <InlineNotice tone="error">{error}</InlineNotice>}
      </div>
    </div>
  );
}
